export default __webpack_public_path__ + "static/media/wuxixishang.c1af41ae.png";